import React from 'react';
import { CALENDAR_VIEW_SEARCH_PARAM, DEFAULT_CALENDAR_VIEW } from '../config/constants';
import { WidgetView } from '../types';

const getInitialWidgetView = () => {
  const url = new URL(window.location.href);
  const calendarView = url.searchParams.get(CALENDAR_VIEW_SEARCH_PARAM);

  if (calendarView === 'month' || calendarView === 'year') {
    return calendarView;
  }

  return DEFAULT_CALENDAR_VIEW;
};

const useCalendarView = (): [WidgetView, (type: WidgetView) => void] => {
  const [widgetView, setWidgetViewState] = React.useState<WidgetView>(getInitialWidgetView());

  const setWidgetView = React.useCallback((_widgetView: WidgetView) => {
    setWidgetViewState(_widgetView);

    const url = new URL(window.location.href);
    url.searchParams.set(CALENDAR_VIEW_SEARCH_PARAM, _widgetView);
    window.history.replaceState({}, '', url.toString());
  }, [setWidgetViewState]);

  return [widgetView, setWidgetView];
};

export default useCalendarView;
